import * as PicklePost from './lib/pickle-post';
import './scss/pickle-post.scss';

PicklePost.init(document.getElementById('pickle-post-locations')!);
